import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { default as fragments } from '../../fragments'

import {
  Spinner,
  FileViewer
} from '../'

import {
  decodeBase64
} from '../../utils'

class RelatedFiles extends React.Component {
  static propTypes = {
    objectId: PropTypes.string.isRequired,
    fileUploaded: PropTypes.bool,
    preview: PropTypes.bool,
    file: PropTypes.string,
    fileType: PropTypes.string,
    fileTypeShortCode: PropTypes.string,
    displayChildren: PropTypes.bool,
    onClick: PropTypes.func
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.fileUploaded) {
      this.props.data.refetch()
    }
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner className='slds-is-relative' size='small' />
    }

    if (this.props.data.error) {
      return <h1>Oh dear! We have an issue</h1>
    }

    let files = this.props.data.filerelations.edges.map(relation => relation.node.file)

    return (
      <FileViewer
        files={files}
        preview={this.props.preview}
        selectFile={this.props.selectfile}
        displayFileChildren={this.props.displayChildren}
        onClick={this.props.onClick}
      />
    )
  }
}

const getFileRelations = gql`
  query($objectId: UUID!, $file: UUID, $fileType: UUID, $fileTypeShortCode: String) {
    filerelations(objectId: $objectId, file_Id: $file, file_Filetype_Id: $fileType, file_Filetype_ShortCode: $fileTypeShortCode) {
      edges {
        node {
          id
          file {
            ...File
          }
        }
      }
    }
  }
  ${fragments.file}
`

const withGetFileRelations =
  graphql(getFileRelations, {
    options: ({ objectId, file, fileType, fileTypeShortCode, selectFile }) => ({
      variables: {
        objectId,
        file: file ? decodeBase64(file) : undefined,
        fileType: fileType ? decodeBase64(fileType) : undefined,
        fileTypeShortCode
      }
    })
  })

export default withGetFileRelations(RelatedFiles)



// WEBPACK FOOTER //
// ./src/components/related-files/index.js